<template>
    <div v-show="hasItems">
        <h2 class="hidden lg:block mt-8 uppercase font-semibold text-base text-grey-dark">
            Periodicity
            <info-helper>Change the periodicity</info-helper>
        </h2>

        <ul class="list-reset flex flex-row flex-wrap">
            <li class="lg:py-2" v-for="p in periodicities">
                <image-button
                        @click.native="changePeriodicity(p.p)"
                        :active="currentPeriodicity === p.p"
                        :img="'/images/svg/' + p.description.toLowerCase() + '.svg'"
                >
                    {{ p.description }}
                </image-button>
            </li>
        </ul>
    </div>
</template>

<script>
    import ImageButton from "./ImageButton";
    import InfoHelper from "./InfoHelper";

    export default {
        components: {InfoHelper, ImageButton},
        computed: {
            currentPeriodicity: function () {
                return this.$store.state.periodicity;
            },
            hasItems() {
                // show this helper only if there a more than one periodicity
                return this.periodicities.length > 1;
            },
            periodicities: function () {
                return this.$store.getters.periodicities;
            },
        },

        methods: {
            changePeriodicity: function (p) {
                this.$store.commit('setPeriodicity', p);
            }
        }

    }

</script>
